export default "__VITE_ASSET__f54cce72__"